import { colors } from "@mui/material";

const colorConfigs = {
  sidebar: {
    bg: "#0a4b75",
    color: "#eeeeee",
    hoverBg: "#d6d6d6",
    activeBg: "#1e6495",
  },

  mainBg: colors.grey["100"],
};

export default colorConfigs;
